module.exports = __webpack_public_path__ + "img/toplab.a0ce6a4a.jpg";